import { Button } from '@axo/ui-core/components/Button';
import { Modal } from '@axo/ui-core/components/Modal';
import { Text } from '@axo/ui-core/components/typography';
import clsx from 'clsx';
import { ReactNode, useState } from 'react';
import { ITerms } from '../../types/Terms';
import { CMSTextUI } from '../CMSTextUI';
import styles from './TermsAndConditionsUI.module.scss';

/**
 * @warning
 * this is a quick and dirty replacement of the deprecated Terms,
 * for the purpose of having a themeable version, using ui-core components
 * @todo the actual component interface needs to be refactored, based on the use cases
 */

interface ITermsAndConditions {
  term: 'general_terms' | 'data_retention' | 'customer_club';
  children?: ReactNode;
  terms: ITerms;
  className?: string;
}

/** @deprecated use TermsAndConditionsUI instead */
export const TermsUI = ({
  term,
  children,
  terms,
  className,
}: ITermsAndConditions) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <span
        className={clsx(styles.clickableTerm, className)}
        onClick={(e) => {
          e.preventDefault();
          setShowModal(true);
        }}
      >
        {children}
      </span>

      <Modal
        onClose={() => setShowModal(false)}
        hasClose={true}
        open={showModal}
      >
        <Modal.Header>
          <Modal.Title size="l">{terms[`${term}_modal_title`]}</Modal.Title>
          <Modal.Subtitle>
            <Text size={'m'}>{terms[`${term}_version`]}</Text>
          </Modal.Subtitle>
        </Modal.Header>

        <section className={styles.paragraphsHolder}>
          <CMSTextUI content={terms[`${term}_intro_paragraph`]} />
        </section>

        <div className={styles.contentHolder}>
          {term === 'general_terms' ? (
            <CMSTextUI content={terms[`${term}`]} />
          ) : (
            <CMSTextUI content={terms[`${term}_terms`]} />
          )}
        </div>
        <Modal.Actions>
          <Button onClick={() => setShowModal(false)}>
            {terms[`${term}_modal_button_text`]}
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};
